/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BillsSummarizedDto as DigiworkMaitreDPosDtoBillsBillsSummarizedDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Bills/bills-summarized-dto';
import { GetBillsPaginatedDto as DigiworkMaitreDPosDtoOrderV2GetBillsPaginatedDto } from '../../models/Digiwork/MaitreD/Pos/DTO/OrderV2/get-bills-paginated-dto';

export interface GetBillsForManagerSummarized$Params {
      body?: DigiworkMaitreDPosDtoOrderV2GetBillsPaginatedDto
}

export function getBillsForManagerSummarized(http: HttpClient, rootUrl: string, params?: GetBillsForManagerSummarized$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoBillsBillsSummarizedDto>> {
  const rb = new RequestBuilder(rootUrl, getBillsForManagerSummarized.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoBillsBillsSummarizedDto>;
    })
  );
}

getBillsForManagerSummarized.PATH = '/api/orders/bills/paginated/summarized';
